/*
 * @Version: 1.0.0
 * @Description: file content
 * @Autor: enbo.zhou@dsicm.com
 * @Date: 2021-05-17 17:22:05
 * @LastEditors: enbo.zhou@dsicm.com
 * @LastEditTime: 2021-05-24 16:34:35
 * @FilePath: /dsicm-admin-web/src/views/scoentific/common/caseConfig-1.js
 */
export default {
    data() {
        return {
            homeColumnConfig: [
                {
                    label: '序号',
                    align: 'center',
                    prop: 'date',
                    fixed: 'left',
                    size: 'mini',
                    render: (h, scope) => {
                        return <span slot="reference">{scope.$index * 1 + 1}</span>
                    },
                },
                {
                    label: '期望支持-数据类型',
                    align: 'center', 
                    prop: 'suport', 
                    size: 'mini',
                    render: (h, scope) => {
                        return <span slot="reference">{ scope.row.suport ? scope.row.suport :'--'}</span>
                    }
                },
                {
                    label: '期望支持-备注',
                    align: 'center',
                    prop: 'remark',
                    size: 'mini',
                    render: (h, scope) => {
                        return <span slot="reference">{ scope.row.remark ? scope.row.remark :'--'}</span>
                    }
                },
                { 
                    label: '项目名称',
                    align: 'center', 
                    prop: 'thirdCategroyName', 
                    size: 'mini',
                    size: 'mini',
                    render: (h, scope) => {
                        return <span slot="reference">{ scope.row.thirdCategroyName ? scope.row.thirdCategroyName :'--'}</span>
                    }
                },

                {
                    label: '项目代码',
                    align: 'center',
                    prop: 'thirdCategoryCode',
                    size: 'mini',
                    render: (h, scope) => {
                        return <span slot="reference">{ scope.row.thirdCategoryCode ? scope.row.thirdCategoryCode :'--'}</span>
                    }
                },

                {
                    label: '归属研究院',
                    align: 'center',
                    prop: 'age',
                    size: 'mini',
                    render: (h, scope) => {
                        return <span slot="reference">{scope.row.researchInstitute == 1 ? '国自然基金委' :'科技部'}</span>
                    },
                },
                {
                    label: '一级学科名称',
                    align: 'center',
                    prop: 'fristCategoryName',
                    size: 'mini',
                    render: (h, scope) => {
                        return <span slot="reference">{ scope.row.fristCategoryName ? scope.row.fristCategoryName :'--'}</span>
                    }
                },
        
                {
                    label: '一级学科代码',
                    align: 'center',
                    prop: 'firstCategoryCode',
                    size: 'mini',
                    render: (h, scope) => {
                        return <span slot="reference">{ scope.row.firstCategoryCode ? scope.row.firstCategoryCode :'--'}</span>
                    }
                },
                {
                    label: '二级学科名称',
                    align: 'center',
                    prop: 'secondCategoryName',
                    size: 'mini',
                    render: (h, scope) => {
                        return <span slot="reference">{ scope.row.secondCategoryName ? scope.row.secondCategoryName :'--'}</span>
                    }
                },
                {
                    label: '二级学科代码',
                    align: 'center',
                    prop: 'secondCategoryCode',
                    render: (h, scope) => {
                        return <span slot="reference">{ scope.row.secondCategoryCode ? scope.row.secondCategoryCode :'--'}</span>
                    }
                },
        
                { 
                    label: '三级学科名称', 
                    align: 'center', 
                    render: (h, scope) => {
                        return <span slot="reference">{ scope.row.thirdCategroyName ? scope.row.thirdCategroyName : '--'}</span>
                    },
                },

                {
                    label: '三级学科代码',
                    align: 'center',
                    size: 'mini',
                    render: (h, scope) => {
                        return <span slot="reference">{ scope.row.thirdCategoryCode ? scope.row.thirdCategoryCode : '--'}</span>
                    },
                },

                {
                    label: '申请团队',
                    align: 'center',
                    size:'mini',
                    prop:'team',
                    render: (h, scope) => {
                        return <span slot="reference">{ scope.row.team ? scope.row.team :'--'}</span>
                    }
                },

                // {
                //     label: '期望支持',
                //     align: 'center',
                //     size:'mini',
                //     prop:'suport'
                // },

                {
                    label: '提交时间',
                    align: 'center',
                    size:'mini',
                    prop:'createTime'
                },
                
                {
                    label: '状态',
                    align: 'center',
                    size: 'mini',
                    render: (h, scope) => {
                        return  <div slot="reference" style="display:flex;align-items:center;justify-content: center">
                                    <p style="width: 6px;height: 6px;background: #8EB0FA;border-radius: 4px;margin-right:6px"></p>
                                    <div >审核中</div>
                                </div>
                    },
                }
            ],
        }
    }
}
  